import React, {useState} from 'react'
import {getLocalStorageItem, getMoneyPathBack, objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {YearDetailClass} from "../components/YearDetailClass"

export const YearDetailPage = () => {
    setLocalStorageItem('page', 'YearDetailPage')
    const [dataModal, setDataModal] = useState({})
    const [preTotalInc, setPreTotalInc] = useState(0)
    const [preTotalExp, setPreTotalExp] = useState(0)
    const [expandIncome, setExpandIncome] = useState(false)
    const [expandExpense, setExpandExpense] = useState(false)
    const lang = objectLang().language
    const l = lang.lang
    const urlParams = new URLSearchParams(window.location.search)
    const year = urlParams.get('year')

    let dataYear = {}
    const globalMoneyObject = getLocalStorageItem('global-money-object')

    if (globalMoneyObject) {
        dataYear = globalMoneyObject[year]
        dataYear.currency = globalMoneyObject['general']['settings']['currencies'][globalMoneyObject['general']['settings']['currency']]
        dataYear.year = year
    } else {
        setDataModal(setErrorWindow('', 999, 'Упсс... Что-то пошло не так!', '', `replaceTo /${l}/`))
        return (
            <ModalWin data={dataModal}/>
        )
    }

    return (
        <>
            <YearDetailClass
                lang={lang}
                dataYear={dataYear}
                expandIncome={expandIncome}
                setExpandIncome={setExpandIncome}
                expandExpense={expandExpense}
                setExpandExpense={setExpandExpense}
                setPreTotalInc={setPreTotalInc}
                preTotalInc={preTotalInc}
                setPreTotalExp={setPreTotalExp}
                preTotalExp={preTotalExp}
                pathBack={getMoneyPathBack()}
            />
        </>
    )
}
